<form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="grid">
        <div class="col-12 md:col-6">
            <div class="form-group">
                <label class="form-label">Name *</label>
                <input type="text" pInputText [formControlName]="'name'" name="name" autocomplete="off"
                    class="form-control" />
                <div *ngIf="form.get('name').invalid && form.get('name').touched" class="text-danger">
                    Name is required.
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6">
            <div class="form-group">
                <label class="form-label">Rate (%) *</label>
                <input type="number" pInputText [formControlName]="'rate'" name="rate" autocomplete="off"
                    class="form-control" />
                <div *ngIf="form.get('rate').invalid && form.get('rate').touched" class="text-danger">
                    Rate is required.
                </div>
            </div>
        </div>
    </div>
    <div class="text-center">
        <p-button type="button" label="Cancel" styleClass="p-button-outlined mr-2" pAutoFocus [autofocus]="true" (click)="exitForm()"></p-button>
        <p-button type="submit" label="Save" styleClass="mr-2" [disabled]="disableSave"></p-button>
    </div>
</form>